import Progress from 'react-progress-2';
import API from '../api/wp';

/**
 * Constants
 */

export const FETCH_PORTFOLIO = 'home/FETCH_PORTFOLIO';
export const FETCH_PORTFOLIO_OK = 'home/FETCH_PORTFOLIO_OK';
export const FETCH_PORTFOLIO_FAILED = 'home/FETCH_PORTFOLIO_FAILED';


/**
 * Actions
 */

export function fetchPortfolio(params = null) {
    return async (dispatch) => {
        dispatch({ type: FETCH_PORTFOLIO });
        Progress.show();

        try {
            const portfolio = await API.getPortfolio(params);
            dispatch({ type: FETCH_PORTFOLIO_OK, portfolio });
            Progress.hide();
        } catch (error) {
            dispatch({ type: FETCH_PORTFOLIO_FAILED });
            Progress.hide();
        }
    }
}


/**
 * Reducer
 */

const initialState = {
    isLoadingPortfolio: false,
    isPortfolioLoaded: false,
    portfolio: [],
};

export default function home(state = initialState, action) {
    switch (action.type) {
        case FETCH_PORTFOLIO:
            return {
                ...state,
                isLoadingPortfolio: true,
            };
        
        case FETCH_PORTFOLIO_OK:
            return {
                ...state,
                isLoadingPortfolio: false,
                isPortfolioLoaded: true,
                portfolio: action.portfolio.data,
            };
        
        case FETCH_PORTFOLIO_FAILED:
            return {
                ...state,
                isLoadingPortfolio: false,
            };

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/modules/home.js